import { getApiBaseUrl } from '../../config/apiBase';
import type {
  CountryDrawerData,
  KeyAreaTargetsResponse,
  TargetsMapData,
  TargetsSummary,
} from './types';

const base = () => getApiBaseUrl();

async function getJson<T>(path: string): Promise<T> {
  const res = await fetch(`${base()}${path}`);
  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new Error(`API ${path} failed: ${res.status} ${text}`);
  }
  return res.json();
}

export function fetchTargetsSummary(): Promise<TargetsSummary> {
  return getJson('/api/targets/summary');
}

export function fetchTargetsMap(params?: {
  key_area_id?: number | null;
  focus_objective_id?: number | null;
  period_id?: number | null;
  activity_type?: string | null;
}): Promise<TargetsMapData> {
  const q = new URLSearchParams();
  if (params?.key_area_id != null) q.set('key_area_id', String(params.key_area_id));
  if (params?.focus_objective_id != null) {
    q.set('focus_objective_id', String(params.focus_objective_id));
  }
  if (params?.period_id != null) q.set('period_id', String(params.period_id));
  if (params?.activity_type) q.set('activity_type', params.activity_type);
  const qs = q.toString();
  return getJson(`/api/targets/map${qs ? `?${qs}` : ''}`);
}

export function fetchCountryDrawer(
  iso3: string,
  keyAreaId?: number | null
): Promise<CountryDrawerData> {
  const q = keyAreaId != null ? `?key_area_id=${keyAreaId}` : '';
  return getJson(`/api/targets/country/${encodeURIComponent(iso3)}${q}`);
}

export function fetchKeyAreaTargets(keyAreaId: number): Promise<KeyAreaTargetsResponse> {
  return getJson(`/api/targets/key-area/${keyAreaId}/targets`);
}

export async function loadMelBoundaries(iso3Codes: string[]) {
  const codes = iso3Codes.length > 0 ? iso3Codes : [];
  try {
    const res = await fetch(
      `${base()}/api/fast-report/country-boundaries?iso3=${codes.join(',')}`
    );
    if (res.ok) {
      const data = await res.json();
      if (data?.type === 'FeatureCollection' && Array.isArray(data.features) && data.features.length) {
        return data;
      }
    }
  } catch (err) {
    console.warn('MEL boundaries proxy failed', err);
  }
  const { fetchCountryBoundaries } = await import('../../utils/maps/countryUtils');
  return fetchCountryBoundaries(codes);
}
